<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <BreadcrumbMenu pageTitle="system_settings" />
    <div v-if="isLoading" class="card border-0 shadow-none rounded-3 mb-4">
      <div class="card-body p-4 p-xl-40 text-center text-optional">
        {{ $t("system_settings_page.loading_settings") }}
      </div>
    </div>
    <template v-else>
      <SystemSettings
        :settings="settings"
        :customers="customers"
        :warehouses="warehouses"
        :logo-url="logoUrl"
        :is-saving="isSaving"
        @update:settings="updateSettings"
        @logo-change="handleLogoChange"
        @submit="saveSettings"
      />
      <CustomerDisplaySettings
        :settings="settings"
        :is-saving="isSaving"
        @update:settings="updateSettings"
        @poster-image-change="handlePosterImageChange"
        @submit="saveSettings"
      />
      <PosReceiptSettings :settings="settings" @update:settings="updateSettings" />
    </template>

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useSystemSettings } from "@/composables/useSystemSettings";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import SystemSettings from "../../components/Settings/SystemSettings/SystemSettings.vue";
import CustomerDisplaySettings from "../../components/Settings/SystemSettings/CustomerDisplaySettings.vue";
import PosReceiptSettings from "../../components/Settings/SystemSettings/PosReceiptSettings.vue";
// import PaymentGateway from "../../components/Settings/SystemSettings/PaymentGateway.vue";
// import SMSConfiguration from "../../components/Settings/SystemSettings/SMSConfiguration.vue";
// import SMTPConfiguration from "../../components/Settings/SystemSettings/SMTPConfiguration.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "SystemSettingsPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    SystemSettings,
    CustomerDisplaySettings,
    PosReceiptSettings,
    // PaymentGateway,
    // SMSConfiguration,
    // SMTPConfiguration,
    MainFooter,
  },
  setup() {
    const {
      settings,
      customers,
      warehouses,
      isLoading,
      isSaving,
      logoUrl,
      saveSettings,
      handleLogoChange,
      handlePosterImageChange,
    } = useSystemSettings();

    return {
      settings,
      customers,
      warehouses,
      isLoading,
      isSaving,
      logoUrl,
      saveSettings,
      handleLogoChange,
      handlePosterImageChange,
      updateSettings: (value: typeof settings.value) => {
        settings.value = value;
      },
    };
  },
});
</script>
